<div class="ps-flex-container-col">
  <h2>Suchen nach Bestellung</h2>

  <mat-form-field>
    <input type="text" placeholder="Aktivität..." matInput [matAutocomplete]="auto" [formControl]="searchFormControl">
    <mat-autocomplete #auto [displayWith]="displayWith" (optionSelected)="onSelect($event)">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        <img [src]="option.icon" matListAvatar>
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
